export default __webpack_public_path__ + "static/media/gray-close-icon.321dabf8.svg";